export default (el) => {
  const rect = el.getBoundingClientRect();
  const { visibilityOffset = 0 } = el.dataset;
  return (
    rect.top + Number(visibilityOffset) <=
    (window.innerHeight || document.documentElement.clientHeight)
  );
};
